"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardAffaireTaches_1 = require("./DashboardAffaireTaches");
var DashboardGroupe = /** @class */function () {
    function DashboardGroupe(data) {
        this.affaireTaches = [];
        if (data != null) {
            this.groupeLibelle = data.groupeLibelle;
            this.ordre = data.ordre;
            this.taskToDoCount = data.taskToDoCount;
            for (var _i = 0, _a = data.affaireTaches; _i < _a.length; _i++) {
                var affTache = _a[_i];
                this.affaireTaches.push(new DashboardAffaireTaches_1.DashboardAffaireTaches(affTache));
            }
        }
    }
    return DashboardGroupe;
}();
exports.DashboardGroupe = DashboardGroupe;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/Models/DashboardGroupe.ts
// module id = 531
// module chunks = 0